import { createFileRoute } from "@tanstack/react-router";

import { getInvestorAnnouncements } from "@/lib/investorAnnouncements";
import { InvestitoriPageContent } from "../investitori";

export const Route = createFileRoute("/en/investitori")({
	ssr: false,
	loader: async () => {
		const announcements = await getInvestorAnnouncements("en");
		return { announcements };
	},
	head: () => ({
		meta: [
			{ title: "Investors | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Investors portal of Makedonijaturist AD. Access to financial reports, business plans, and important information for shareholders.",
			},
			{
				name: "robots",
				content: "noindex, nofollow",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/investitori",
			},
		],
	}),
	component: EnInvestitoriPage,
});

function EnInvestitoriPage() {
	const { announcements } = Route.useLoaderData();
	return <InvestitoriPageContent announcements={announcements} />;
}
